import IRequest from "../../IRequest";

export interface ILocaisCobranca {
    reqTiposDocumentos: IRequest<TLocalCobranca>,
    dataTiposDocumentos: TLocalCobranca[]
  }

export type TLocalCobranca = {
  codigo: string;
  nome: string;
}

export const defValueLocalCobranca: TLocalCobranca = {
  codigo: '',
  nome: '',
}